import { ActivityLogTypeEnum } from '@/@data'
import { LiftActivityLog } from '@/components/log/LiftActivityLog'
import Link from '@/components/Link';
import { useRouteQuery } from '@/hooks';

export const EmployerDetailActivityLog = () => {
  const { __ } = useTranslator();
  const { params } = useRouteQuery();
  const { id } = params;

  return (
    <LiftActivityLog
      object_type={ActivityLogTypeEnum.Company}
      object_id={id}
      breadcrumb={
        <Link color='inherit' href='/cms/employer'>
          {__('Employer Management')}
        </Link>
      }
    />
  )
}
